import { useState } from 'react';

export function useSort(initSortBy: string, initSortDirection: 'asc' | 'desc') {
  const [sortBy, setSortBy] = useState(initSortBy);

  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>(
    initSortDirection
  );

  const toggleSort = (name: string) => {
    if (name === sortBy) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(name);

      setSortDirection('asc');
    }
  };

  return { toggleSort, sortBy, sortDirection };
}
